import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-signed-rc-report',
    templateUrl: './signed-rc-report.component.html',
    styleUrls: ['./signed-rc-report.component.scss'],
    standalone: false
})
export class SignedRcReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
